import * as React from 'react'
import { Switch, Route } from 'react-router-dom'
import { History, Location } from 'history'
import { withNavigation } from 'hocs'
import { match as RouteMatch } from 'react-router-dom'
import { Navigation } from 'navigation'
import PersonalSection from './personalSection'
import PasswordSection from './passwordSection'
import ServiceAppsSection from './serviceApps'
import { ConnectAppLink } from './serviceApps/components/connectApp'
import './personalSettingsContainer.scss'
import { Profile } from 'settings/schema'
import { AccountSettingsService } from 'settings/settingsService'
import { UpdatedAccountDetails, PersonalSettingsParams } from 'settings/schema'
import { Container, ContainerBody } from 'uiComponents/settingsContainer'
import { UnderlineNavigationTabs } from 'uiComponents/navigation/underlineNavigationTabs'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'
import { User } from 'auth/state'
import { withFeatures } from 'features'
import { t } from 'translations'

interface SettingsContainerState {
    welcome: boolean
    activeSection: string
}

interface SettingsContainerProps {
    accountSlug: string
    user: User | null
    accountSettingsService: AccountSettingsService
    history: History
    navigation: Navigation
    match: RouteMatch<PersonalSettingsParams>
    profile: Profile
    onSave: (newDetails: UpdatedAccountDetails, password: string) => void
    resendEmail: () => void
    location: Location
    welcomePage: boolean
    loading: boolean
    avatar?: React.ReactNode
    hasFeature: (feature: string, accountSlug: string) => boolean
}

class AccountSettingsContainer extends React.Component<SettingsContainerProps, SettingsContainerState> {
    constructor(props: SettingsContainerProps) {
        super(props)
        this.state = {
            welcome: this.props.welcomePage,
            activeSection: '',
        }
    }

    setActiveSection = (section: string) => {
        this.setState({ activeSection: section })
    }

    render() {
        const { welcome, activeSection } = this.state
        const { profile, onSave, resendEmail, location } = this.props
        const resellerPages = !!this.props.user?.resellerId && this.props.user.accounts.length > 1
        const sectionPath = (section: string) => `${resellerPages ? '/resellers' : ''}/personal_settings/${section}`

        const serviceApps = location.pathname.includes('service_apps')

        return (
            <>
                {!welcome && (
                    <InSectionTabsSlot>
                        <UnderlineNavigationTabs
                            tabs={[
                                {
                                    name: 'Personal',
                                    current: activeSection === 'personal',
                                    href: sectionPath('personal'),
                                    onClick: () => this.props.history.push(sectionPath('personal')),
                                },
                                {
                                    name: 'Password',
                                    current: activeSection === 'password',
                                    href: sectionPath('password'),
                                    onClick: () => this.props.history.push(sectionPath('password')),
                                },
                                {
                                    name: t('settings.personalSettings.tabs.serviceApps'),
                                    current: activeSection === 'service_apps',
                                    href: sectionPath('service_apps'),
                                    onClick: () => this.props.history.push(sectionPath('service_apps')),
                                },
                            ]}
                        />
                    </InSectionTabsSlot>
                )}
                <Container id="personal-settings" className={serviceApps ? 'has-page-footer' : undefined}>
                    <ContainerBody style={{ flexDirection: 'column' }} noPadding={serviceApps}>
                        {this.props.avatar}
                        {!welcome && (
                            <Switch location={location}>
                                <Route
                                    path="/personal_settings/personal"
                                    render={() => (
                                        <PersonalSection
                                            profile={profile}
                                            onSave={onSave}
                                            resendEmail={resendEmail}
                                            welcome={welcome}
                                            setActiveSection={this.setActiveSection}
                                            loading={this.props.loading}
                                        />
                                    )}
                                />
                                <Route
                                    path="/personal_settings/password"
                                    render={() => (
                                        <PasswordSection
                                            accountSettingsService={this.props.accountSettingsService}
                                            profile={profile}
                                            setActiveSection={this.setActiveSection}
                                        />
                                    )}
                                />
                                <Route
                                    path="/personal_settings/service_apps"
                                    render={() => <ServiceAppsSection setActiveSection={this.setActiveSection} />}
                                />
                                <Route
                                    path="/resellers/personal_settings/service_apps"
                                    render={() => <ServiceAppsSection setActiveSection={this.setActiveSection} />}
                                />
                                <Route
                                    path="/resellers/personal_settings/personal"
                                    render={() => (
                                        <PersonalSection
                                            profile={profile}
                                            onSave={onSave}
                                            resendEmail={resendEmail}
                                            welcome={welcome}
                                            setActiveSection={this.setActiveSection}
                                            loading={this.props.loading}
                                        />
                                    )}
                                />
                                <Route
                                    path="/resellers/personal_settings/password"
                                    render={() => (
                                        <PasswordSection
                                            accountSettingsService={this.props.accountSettingsService}
                                            profile={profile}
                                            setActiveSection={this.setActiveSection}
                                        />
                                    )}
                                />
                            </Switch>
                        )}
                        {welcome && (
                            <PersonalSection
                                profile={profile}
                                onSave={onSave}
                                resendEmail={resendEmail}
                                welcome={welcome}
                                setActiveSection={this.setActiveSection}
                                loading={this.props.loading}
                            />
                        )}
                    </ContainerBody>
                </Container>
                {serviceApps && <ConnectAppLink />}
            </>
        )
    }
}

export default withFeatures(withNavigation(AccountSettingsContainer))
